import { render } from "./SkewT.vue?vue&type=template&id=ca086e1a"
import script from "./SkewT.vue?vue&type=script&lang=js"
export * from "./SkewT.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__